"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function BlogSvg(props) {
    return react_1.default.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: 30, height: 30, viewBox: "0 0 30 30" }, props),
        react_1.default.createElement("desc", null, "Created with Sketch."),
        react_1.default.createElement("g", { transform: "translate(-54 -743) translate(54 743)" },
            react_1.default.createElement("circle", { cx: 15, cy: 15, r: 12, fill: "#FFF" }),
            react_1.default.createElement("path", { fill: "#FF6161", d: "M15 0c8.284 0 15 6.716 15 15 0 8.284-6.716 15-15 15-8.284 0-15-6.716-15-15C0 6.716 6.716 0 15 0zM9 11.666v2.668c3.676 0 6.667 2.99 6.667 6.666h2.666c0-5.146-4.187-9.334-9.333-9.334zM11 17c-1.104 0-2 .895-2 2s.896 2 2 2c1.105 0 2-.895 2-2s-.895-2-2-2zM9 7v2.666c6.25 0 11.334 5.085 11.334 11.334H23c0-7.72-6.28-14-14-14z" })));
}
function Blog(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(BlogSvg, Object.assign({}, svgProps)));
}
exports.default = Blog;
//# sourceMappingURL=Blog.js.map